
import { Link } from "react-router-dom";
import codematicLogo from "@/assets/codematic-logo.png";

const LoginNavbar = () => {
  return (
    <div className="bg-white border-b border-gray-200 flex items-center justify-center p-4">
      <Link to="">
        <img src={codematicLogo} alt="Codematic Logo" className="h-8 w-auto" />
      </Link>
    </div>
  );
};

export default LoginNavbar;
